export default __webpack_public_path__ + "static/media/gray-small-glow.327f5b7a.png";